import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  lastPage: {
    marginLeft: theme.spacing(2),
  },
  pageSelect: {
    alignItems: 'center',
  },
  pageSelectContainer: {
    maxWidth: 400,
  },
  pageSelectInput: {
    textAlign: 'center',
  },
  pageSelectInputRoot: {
    border: `1px solid ${theme.palette.common.gray300}`,
    borderRadius: 3,
    height: 32,
    margin: theme.spacing(0, 2),
    width: 53,
  },
  paginationContent: {
    position: 'relative',
  },
  paginationLeftContent: {
    left: 0,
    position: 'absolute',
  },
  root: {
    padding: theme.spacing(3, 2, 3),
    width: '100%',
  },
  rowsPerPage: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  rowsPerPageSelect: {
    marginLeft: theme.spacing(1),
  },
}));
